import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './style/index.scss'
import { http } from "./utils/request"

import './permission' // permission control
import login from './utils/login/Logins'
import $ from 'jquery'
Vue.prototype.$login = login.install
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$http = http;
//预览地址
Vue.prototype.$previewurl = 'http://172.16.26.124:8012';
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')